export default "__VITE_ASSET__DShGF895__"